import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useResponsive } from 'src/hooks/use-responsive';

type Props = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};

export default function AuthClassicLayout({ children, image, title }: Props) {

  const renderSection = (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        component="img"
        alt="auth"
        src={image || '/assets/images/login/login.jpeg'}
        sx={{ height: '100vh', width: '100%', objectFit: 'cover' }}
      />
      {children}
    </Stack>
  );

  return (
    <Stack
  component="main"
  direction="row"
  sx={{
    minHeight: '100vh',
    position: 'relative', // needed for absolute positioning
  }}
    >
      {renderSection}
    </Stack>
  );
}
